import { routerPostCall } from '../../axios';

const referralVerification = (state, params) => {
  const url = `/auth/referrals`;
  return routerPostCall(state, url, params);
};

export default { referralVerification };
